import React from 'react';

export default (props) => {
  let cls = 'warning';
  let text = 'Kladd';

  if (props.entry.published) {
    if (props.entry.updated) {
      cls = 'info';
      text = 'Endret';
    } else {
      cls = 'success';
      text = 'Publisert';
    }
  } else if (props.entry.archived) {
    cls = 'danger';
    text = 'Arkivert';
  }

  return (
    <span className={`text-${cls}`} title={text}>
      <i className="fa fa-circle" aria-hidden="true"></i>
      <span className="sr-only">{text}</span>
    </span>
  );
};
